import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

interface DeleteTransactionModalProps {
  isOpen: boolean
  onClose: () => void
  isSubmitting?: boolean
  isRecurring?: boolean
  onSubmit: (scope: 'single' | 'group' | 'end') => Promise<void>
}

export function DeleteTransactionModal({
  isOpen,
  onClose,
  isSubmitting,
  isRecurring = false,
  onSubmit,
}: DeleteTransactionModalProps) {
  const [action, setAction] = useState<string>('')
  const toast = useToast()

  useEffect(() => {
    if (isOpen) {
      setAction('')
    }
  }, [isOpen])

  const handleSubmit = async () => {
    // Se não for recorrência, usar scope 'single' diretamente
    if (!isRecurring) {
      try {
        await onSubmit('single')
      } catch (error) {
        console.error('Erro ao excluir:', error)
      }
      return
    }

    // Se for recorrência, validar a opção escolhida
    if (!action) {
      toast({ description: 'Por favor, digite uma opção.', status: 'warning' })
      return
    }

    if (!['1', '2', '3'].includes(action)) {
      toast({ description: 'Opção inválida. Digite 1, 2 ou 3.', status: 'error' })
      return
    }

    const scope = action === '1' ? 'single' : action === '2' ? 'group' : 'end'
    try {
      await onSubmit(scope)
    } catch (error) {
      // Erro já é tratado no componente pai
      console.error('Erro ao excluir:', error)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg="gray.800">
        <ModalHeader>Excluir Lançamento</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isRecurring ? (
            <>
              <Text mb={4} color="gray.300">
                Digite:
              </Text>
              <VStack align="stretch" spacing={2} mb={4} color="gray.300">
                <Text>1 - Excluir apenas este lançamento</Text>
                <Text>2 - Excluir toda a recorrência</Text>
                <Text>3 - Encerrar recorrência</Text>
              </VStack>
              <FormControl>
                <FormLabel>Opção</FormLabel>
                <Input
                  type="text"
                  value={action}
                  onChange={(e) => setAction(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Digite 1, 2 ou 3"
                  autoFocus
                  maxLength={1}
                />
              </FormControl>
            </>
          ) : (
            <Text color="gray.300">
              Tem certeza que deseja excluir este lançamento? Esta ação não pode ser desfeita.
            </Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="red" onClick={handleSubmit} isLoading={isSubmitting}>
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

